import {
  SET_DUPLICATION_CHECK_LIST,
  SET_DUPLICATION_CHECK_PAGE_NUM,
  SET_DUPLICATION_CHECK_PAGE_SIZE,
  SET_DUPLICATION_CHECK_PAGE_SIZE_TOTAL,
  SET_DUPLICATION_CHECK_QUERY,
  SET_DUPLICATION_CHECK_SEARCHING,
} from './mutation-types.js'
import api from '@/api'
import _ from 'lodash'

const initQuery = () => ({
  pageSize: 50,
  pageNum: 1,
  userName: '',
  userId: '',
  fatherUuid: '',
  phone: '',
  email: '',
})

const state = {
  searching: false,
  initQuery: initQuery(),
  userDuplicationCheck: {
    list: [],
    listPagTotal: 0,
    query: initQuery(),
  },
}

const mutations = {
  [SET_DUPLICATION_CHECK_LIST] (state, payload) {
    state.userDuplicationCheck.list = payload
  },
  [SET_DUPLICATION_CHECK_PAGE_NUM] (state, payload) {
    state.userDuplicationCheck.query.pageNum = payload
  },
  [SET_DUPLICATION_CHECK_PAGE_SIZE] (state, payload) {
    state.userDuplicationCheck.query.pageSize = payload
  },
  [SET_DUPLICATION_CHECK_PAGE_SIZE_TOTAL] (state, payload) {
    state.userDuplicationCheck.listPageTotal = payload
  },
  [SET_DUPLICATION_CHECK_QUERY] (state, payload) {
    state.userDuplicationCheck.query = {
      ...state.userDuplicationCheck.query,
      ...payload,
    }
  },
  [SET_DUPLICATION_CHECK_SEARCHING](state, payload) {
    state.searching = payload
  },
}

const actions = {
  async getUserDuplicationCheck({commit, state}, payload) {
    try {
      commit(SET_DUPLICATION_CHECK_SEARCHING, true)
      let query = {}
      _.forIn(state.userDuplicationCheck.query, (v, k) => {
        if (v !== '') query[k] = v
      })
      let params = {
        ...query,
        ...payload,
      }
      let {data: {items, total}} = await api.userApi.getPlagiarismCheck(params)
      commit(SET_DUPLICATION_CHECK_SEARCHING, false)
      commit(SET_DUPLICATION_CHECK_LIST, items)
      commit(SET_DUPLICATION_CHECK_PAGE_SIZE_TOTAL, total)
      return items
    } catch (error) {
      commit(SET_DUPLICATION_CHECK_SEARCHING, false)
      commit(SET_DUPLICATION_CHECK_PAGE_SIZE_TOTAL, 0)
      commit(SET_DUPLICATION_CHECK_LIST, [])
    }
  },
  setUserDuplicationCheckQuery ({commit}, payload) {
    commit(SET_DUPLICATION_CHECK_QUERY, payload)
  },
  async initUserDuplicationCheck ({dispatch}) {
    await dispatch('setUserDuplicationCheckQuery', state.initQuery)
    await dispatch('getUserDuplicationCheck')
  },
  // 改变每页显示条数
  changePageSize ({commit, dispatch}, payload) {
    commit(SET_DUPLICATION_CHECK_PAGE_SIZE, payload.pageSize)
    commit(SET_DUPLICATION_CHECK_PAGE_NUM, 1)
  },
  setPageNum ({commit, dispatch}, payload) {
    commit(SET_DUPLICATION_CHECK_PAGE_NUM, payload.currentPage)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
